import React from 'react'
import translations from './translations'

translations.add('en', {
    unknown: 'Unknown',
    footerText: (url: string) => <>Provided by <a href={url} target='_blank'>Ecospend</a>, licensed by the FCA</>
})
